import { encode } from 'base64-arraybuffer'

import { base64ToBase64Url } from '@cash-web/shared/util-encoding'

export function encodeCredential(credential: PublicKeyCredential & { response: AuthenticatorAssertionResponse }) {
  const encodedRawId = base64ToBase64Url(encode(credential.rawId))
  const encodedAuthenticatorData = base64ToBase64Url(encode(credential.response.authenticatorData))
  const encodedClientDataJSON = base64ToBase64Url(encode(credential.response.clientDataJSON))
  const encodedSignature = base64ToBase64Url(encode(credential.response.signature))
  const encodedUserHandle = credential.response.userHandle
    ? base64ToBase64Url(encode(credential.response.userHandle))
    : undefined

  const encodedCredential = {
    authenticatorAttachment: credential.authenticatorAttachment,
    id: credential.id,
    rawId: encodedRawId,
    response: {
      authenticatorData: encodedAuthenticatorData,
      clientDataJSON: encodedClientDataJSON,
      signature: encodedSignature,
      userHandle: encodedUserHandle,
    },
    clientExtensionResults: {},
    type: credential.type,
  }

  return encodedCredential
}
